const MonitoramentoProva = () =>
  import("~/components/Views/Prova/Monitor/MonitoramentoProva");

import auth from "~/middleware/auth";
import monitor from "~/middleware/monitor";
import grupoVerify from "~/middleware/grupoVerify";
import perfilVerify from "~/middleware/perfilVerify";

const breadcrumb = [
  { name: "Integrado", link: "http://on.grupointegrado.br/" },
  { name: "Prova", link: "" },
  { name: "Relatórios", link: "" }
];

export const monitoramentoProva = [
  {
    path: "relatorios/monitoramento",
    component: MonitoramentoProva,
    name: "Monitoramento de Provas",
    meta: {
      title: "Monitoramento de Provas",
      middleware: [auth, monitor, grupoVerify, perfilVerify],
      breadcrumb
    }
  }
];



// WEBPACK FOOTER //
// ./src/routes/prova/relatorio/monitoramentoProva.js